<template>
    <div class="container">
        <div class="row">
            <div class="col">
                <h3 class="page-title">System users</h3>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <table class="table table-hover table-sm">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Access level</th>
                        <th>Status</th>
                        <th v-if="$isSuperAdmin()">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user, $index) in users">
                            <td>{{ $index + 1}}</td>
                            <td>
                                {{user.name}}
                            </td>
                            <td>
                                {{user.email}}
                            </td>
                            <td>
                                <span v-if="!$isSuperAdmin()">{{user.access_level}}</span>
                                <select v-else :disabled="user.processing" @change="onAccessLevelUpdated(user)" class='form-control form-control-sm' v-model="user.access_level">
                                    <option value>None</option>
                                    <option value="guest">Guest</option>
                                    <option value="admin">Admin</option>
                                    <option value="superadmin">Superadmin</option>
                                </select>
                            </td>
                            <td>
                                <span class="user-status" :class="{ approved: user.approved }">
                                    {{ user.approved ? 'Approved' : 'Rejected' }}
                                </span>
                            </td>
                            <td v-if="$isSuperAdmin()">
                                <button type="button" :disabled="user.processing" class="btn btn-sm btn-primary" @click="deleteUser(user)">
                                    <i class="fa fa-trash"></i>
                                </button>
                                <button type="button" :disabled="user.processing" class="btn btn-sm btn-primary" @click="approveUser(user)" v-if="!user.approved">Approve</button>
                                <button type="button" :disabled="user.processing" class="btn btn-sm btn-primary" @click="rejectUser(user)" v-if="user.approved">Reject</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import * as _ from 'lodash';

    export default {
        name: 'UsersList',
        data () {
            return {
                users: []
            }
        },
        mounted(){
            this.$usersSerive.getAllUsers().then(({data}) => {
                this.users = data;
            });
        },
        methods: {
            approveUser(user){
                user.updating = true;
                this.$usersSerive
                    .approveUser(user.id)
                    .then(this.mergeUser(user))
                    .catch(this.onUserUpdateError(user))
            },
            rejectUser(user){
                user.updating = true;
                this.$usersSerive
                    .rejectUser(user.id)
                    .then(this.mergeUser(user))
                    .catch(this.onUserUpdateError(user))
            },
            mergeUser(user){
                return (response) => {
                    user.updating = false;
//                    let currentUser = this.users.find(u => u.id = response.data.id);
                    user = Object.assign(user, response.data.user);
                }
            },
            onUserUpdateError(user){
                return (response) => {
                    user.updating = false;
//                    let currentUser = this.users.find(u => u.id = data.id);
//                    user = Object.assign(user, response.data);
                    this.$swal({
                        type: 'error',
                        title: 'An error occurred',
                        text: response.data.err
                    });
                }
            },
            onAccessLevelUpdated(user){
                this.$usersSerive
                    .updateAccessLevel(user.id, user.access_level)
                    .then(this.mergeUser(user))
                    .catch(this.onUserUpdateError(user))
            },
            deleteUser(user){
                this.$usersSerive
                    .deleteUser(user.id)
                    .then(() => {
                        this.users = this.users.filter((i) => {
                            return i.id !== user.id
                        })
                    })
                    .catch(this.onUserUpdateError(user))
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .table{
        tbody{
            tr{
                &.wo-pending{
                    background: #d7fbcb;
                }
            }
        }
    }

    .user-status{
        padding: 0 5px;
        font-size: 12px;
        border-radius: 4px;
        background: $dangerBackground;
        color: $dangerColor;
        &.approved{
            color: #333;
            background: $successBackground;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/users/users.component.vue